import { cn } from '@/lib/utils';
import type { ButtonProps, ButtonVariant, ButtonSize } from '@/types/components.types';

const VARIANTS: Record<ButtonVariant, string> = {
  primary:   'bg-violet-600 hover:bg-violet-700 text-white shadow-[0_0_20px_rgba(139,92,246,0.3)]',
  secondary: 'bg-zinc-800 hover:bg-zinc-700 text-zinc-50 border border-zinc-700',
  ghost:     'hover:bg-zinc-800 text-zinc-400 hover:text-zinc-50',
  outline:   'border border-zinc-700 hover:border-zinc-600 text-zinc-300 hover:text-zinc-50 bg-transparent',
  danger:    'bg-red-500/10 text-red-500 hover:bg-red-500/20 border border-red-500/20',
};

const SIZES: Record<ButtonSize, string> = {
  sm:      'px-3 py-1.5 text-sm',
  default: 'px-4 py-2 text-sm',
  lg:      'px-6 py-3 text-base font-medium',
};

export const Button = ({
  children, variant = 'primary', size = 'default',
  className, type = 'button', ...props
}: ButtonProps) => (
  <button
    type={type}
    className={cn(
      'inline-flex items-center justify-center rounded-lg font-medium',
      'transition-all duration-200 cursor-pointer',
      'focus:outline-none focus:ring-2 focus:ring-violet-500/50',
      'disabled:opacity-50 disabled:pointer-events-none',
      VARIANTS[variant], SIZES[size], className,
    )}
    {...props}
  >
    {children}
  </button>
);
